import React, { Dispatch, SetStateAction } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

import FlexWrap from '@/components/common/FlexWrap';

type ViewSelectorProps = {
  setSize: Dispatch<SetStateAction<number>>;
  setPageNumber: Dispatch<SetStateAction<number>>;
};

function GlobalPaymentViewSelector({
  setSize,
  setPageNumber,
}: ViewSelectorProps) {
  const options = [
    { label: '10개씩 보기', value: 10 },
    { label: '100개씩 보기', value: 100 },
    { label: '500개씩 보기', value: 500 },
  ];

  const onChange = (e: any) => {
    setSize(e.value);
    setPageNumber(0);
  };
  return (
    <ViewContainer>
      <Select
        isSearchable={false}
        //@ts-ignore
        defaultValue={options[2]}
        onChange={onChange}
        //@ts-ignore
        options={options}
        styles={{
          container: (baseStyles: any) => ({
            ...baseStyles,
            marginLeft: 'auto',
            padding: 3,
            backgroundColor: 'transparent',
            border: '1.5px solid #CBCCCE',
            borderRadius: 4,
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            height: '44px',
            width: '148px',
          }),
          control: () => ({
            display: 'flex',
            alignItems: 'center',
            height: 22,
            width: 200,
          }),
          indicatorSeparator: () => ({
            width: 0,
          }),
          singleValue: (baseStyles: any) => ({
            ...baseStyles,
            color: '#80848A',
            fontFamily: 'Pretendard',
            fontWeight: '500',
          }),
        }}
      />
    </ViewContainer>
  );
}

const ViewContainer = styled(FlexWrap)`
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
`;

export default GlobalPaymentViewSelector;
